<template>
  <div class="mod-article-inner">
    <preview-job-content-header title="この仕事の向き・不向き" />
    <p class="orient">
      向いている人
    </p>
    <p
      class="pega-pre-wrap"
      data-test="suitable"
      v-text="suitable"
    />
    <p class="orient">
      向いていない人
    </p>
    <p
      class="pega-pre-wrap"
      data-test="not-suitable"
      v-text="notSuitable"
    />
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/base" as *;
</style>

<script>
import PreviewJobContentHeader from '@/components/atoms/PreviewJobContentHeader'

export default {
  components: {
    PreviewJobContentHeader
  },
  props: {
    suitable: {
      type: String,
      required: true
    },
    notSuitable: {
      type: String,
      required: true
    }
  }
}
</script>
